import { useQuery } from '@tanstack/react-query';
import apiClient from '@/api/client';
import { ENDPOINTS } from '@/api/endpoints';
import type { ApiEnvelope } from '@/types/dashboard/auth';

export interface SiteInfo {
  /** Public informational website; null until WEBSITE_URL is set on the backend */
  website_url: string | null;
  app_url: string | null;
}

export const siteService = {
  async getInfo(): Promise<SiteInfo> {
    const { data } = await apiClient.get<ApiEnvelope<SiteInfo>>(ENDPOINTS.siteInfo);
    return data.data;
  },
};

export function useSiteInfo() {
  return useQuery({
    queryKey: ['site-info'] as const,
    queryFn: () => siteService.getInfo(),
    staleTime: 10 * 60 * 1000,
  });
}
